import { ConclusionContext } from "@Providers/ConclusionProvider"
import { userAtom } from "@Recoil/Atom/userAtom"
import { ConclusionService } from "@Services/Conclusion.Service"
import { useContext, useEffect, useState } from "react"
import { useRecoilState } from "recoil"

export const useConclusionHooks = () => {
    const [fetchingConclusions, setFetchingConclusions] = useState(true)
    const [user, setUser] = useRecoilState(userAtom)
    const [conclusion, setConclusion] = useState({})
    const patientId = user?.id
    const {
        setFetchingConclusions: setFetchingConclusionsFromContext,
        setCurrentConclusion,
        setConclusions
    } = useContext(ConclusionContext)

    const handleFetchConclusion = async () => {
        setFetchingConclusions(true)
        setFetchingConclusionsFromContext(true)
        ConclusionService.getPatientConclusion(patientId)
            .then((res) => {
                const data = res?.data?.data
                const resume = data?.[data?.length - 1]
                setConclusions(data)
                setConclusion(resume)
                setCurrentConclusion(resume)
                setFetchingConclusions(false)
                setFetchingConclusionsFromContext(false)
            })
            .catch(() => {
                setFetchingConclusions(false)
                setFetchingConclusionsFromContext(false)
            })
    }

    useEffect(() => {
        console.log("conclusion", conclusion)
    }, [conclusion])
    return {
        handleFetchConclusion,
        conclusion,
        fetchingConclusions
    }
}
